module.exports = __webpack_public_path__ + "static/media/nyan.afcec0ef.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/nyan.gif
// module id = 822
// module chunks = 1